
import React from 'react';
import { FacilityOrderTemplateNewFlowUSIntakeClinicalStatusNoteModalTemplate } from 'themes/application/facility-order-new-flow-us-intake/components';
import { observer } from 'mobx-react';
import { setCurrentView } from 'core/utils';
import { FacilityOrderTemplateNewFlowUSIntakeClinicalStatusNoteModalStore } from 'application/facility-order-new-flow-us-intake/stores';

@setCurrentView((rootStore, componentProps) => new FacilityOrderTemplateNewFlowUSIntakeClinicalStatusNoteModalStore(rootStore, componentProps), 'facilityOrderTemplateNewFlowUSIntakeClinicalStatusNoteModalStore')
@observer
class FacilityOrderTemplateNewFlowUSIntakeClinicalStatusNoteModal extends React.Component {
    render() {
        return <FacilityOrderTemplateNewFlowUSIntakeClinicalStatusNoteModalTemplate {...this.props} />
    }
}

export default FacilityOrderTemplateNewFlowUSIntakeClinicalStatusNoteModal;
